const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

// Keyboard control with wrap for Dawn sliders/slideshows
document.addEventListener('keydown', function (e) {
  if (e.defaultPrevented) return;
  if (e.altKey || e.ctrlKey || e.metaKey) return;

  const t = e.target;
  if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;

  if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

  const sliders = Array.from(document.querySelectorAll('slider-component, slideshow-component'));
  if (!sliders.length) return;

  // Pick the most-visible slider on screen
  const mostVisible =
    sliders
      .map(el => {
        const r = el.getBoundingClientRect();
        const w = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
        const h = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
        return { el, area: w * h };
      })
      .sort((a, b) => b.area - a.area)[0]?.el || sliders[0];

  const prevBtn = mostVisible.querySelector('.slider-button--prev, [name="previous"]');
  const nextBtn = mostVisible.querySelector('.slider-button--next, [name="next"]');

  // Dawn's pagination dots/buttons (works across versions)
  const dots = mostVisible.querySelectorAll('.slider-counter__link, [data-pagination] button, [data-pagination] a');
  const firstDot = dots[0];
  const lastDot  = dots[dots.length - 1];

  // Helper: is a nav button disabled?
  const isDisabled = (btn) =>
    !btn || btn.hasAttribute('disabled') ||
    btn.getAttribute('aria-disabled') === 'true' ||
    btn.classList.contains('disabled');

  if (e.key === 'ArrowRight') {
    if (isDisabled(nextBtn)) {
      // wrap to first without “rewinding”
      if (firstDot) firstDot.click();
      else if (mostVisible.querySelector('[data-slide]:first-child a, [data-slide]:first-child button')) {
        mostVisible.querySelector('[data-slide]:first-child a, [data-slide]:first-child button').click();
      }
    } else {
      nextBtn.click();
    }
    e.preventDefault();
  }

  if (e.key === 'ArrowLeft') {
    if (isDisabled(prevBtn)) {
      // wrap to last
      if (lastDot) lastDot.click();
      else if (mostVisible.querySelector('[data-slide]:last-child a, [data-slide]:last-child button')) {
        mostVisible.querySelector('[data-slide]:last-child a, [data-slide]:last-child button').click();
      }
    } else {
      prevBtn.click();
    }
    e.preventDefault();
  }
});
